export type Timezone = {
  id: string
  name: string
  value: string
  intlValue?: string
}[];

export default [
  {
    id: 'Africa/Abidjan',
    name: 'Africa/Abidjan',
    value: 'Africa/Abidjan',
  },
  {
    id: 'Africa/Accra',
    name: 'Africa/Accra',
    value: 'Africa/Accra',
  },
  {
    id: 'Africa/Addis_Ababa',
    name: 'Africa/Addis Ababa',
    value: 'Africa/Addis_Ababa',
  },
  {
    id: 'Africa/Algiers',
    name: 'Africa/Algiers',
    value: 'Africa/Algiers',
  },
  {
    id: 'Africa/Asmara',
    name: 'Africa/Asmara',
    value: 'Africa/Asmara',
  },
  {
    id: 'Africa/Bamako',
    name: 'Africa/Bamako',
    value: 'Africa/Bamako',
  },
  {
    id: 'Africa/Bangui',
    name: 'Africa/Bangui',
    value: 'Africa/Bangui',
  },
  {
    id: 'Africa/Banjul',
    name: 'Africa/Banjul',
    value: 'Africa/Banjul',
  },
  {
    id: 'Africa/Bissau',
    name: 'Africa/Bissau',
    value: 'Africa/Bissau',
  },
  {
    id: 'Africa/Blantyre',
    name: 'Africa/Blantyre',
    value: 'Africa/Blantyre',
  },
  {
    id: 'Africa/Brazzaville',
    name: 'Africa/Brazzaville',
    value: 'Africa/Brazzaville',
  },
  {
    id: 'Africa/Bujumbura',
    name: 'Africa/Bujumbura',
    value: 'Africa/Bujumbura',
  },
  {
    id: 'Africa/Cairo',
    name: 'Africa/Cairo',
    value: 'Africa/Cairo',
  },
  {
    id: 'Africa/Casablanca',
    name: 'Africa/Casablanca',
    value: 'Africa/Casablanca',
  },
  {
    id: 'Africa/Ceuta',
    name: 'Africa/Ceuta',
    value: 'Africa/Ceuta',
  },
  {
    id: 'Africa/Conakry',
    name: 'Africa/Conakry',
    value: 'Africa/Conakry',
  },
  {
    id: 'Africa/Dakar',
    name: 'Africa/Dakar',
    value: 'Africa/Dakar',
  },
  {
    id: 'Africa/Dar_es_Salaam',
    name: 'Africa/Dar es Salaam',
    value: 'Africa/Dar_es_Salaam',
  },
  {
    id: 'Africa/Djibouti',
    name: 'Africa/Djibouti',
    value: 'Africa/Djibouti',
  },
  {
    id: 'Africa/Douala',
    name: 'Africa/Douala',
    value: 'Africa/Douala',
  },
  {
    id: 'Africa/El_Aaiun',
    name: 'Africa/El Aaiun',
    value: 'Africa/El_Aaiun',
  },
  {
    id: 'Africa/Freetown',
    name: 'Africa/Freetown',
    value: 'Africa/Freetown',
  },
  {
    id: 'Africa/Gaborone',
    name: 'Africa/Gaborone',
    value: 'Africa/Gaborone',
  },
  {
    id: 'Africa/Harare',
    name: 'Africa/Harare',
    value: 'Africa/Harare',
  },
  {
    id: 'Africa/Johannesburg',
    name: 'Africa/Johannesburg',
    value: 'Africa/Johannesburg',
  },
  {
    id: 'Africa/Juba',
    name: 'Africa/Juba',
    value: 'Africa/Juba',
  },
  {
    id: 'Africa/Kampala',
    name: 'Africa/Kampala',
    value: 'Africa/Kampala',
  },
  {
    id: 'Africa/Khartoum',
    name: 'Africa/Khartoum',
    value: 'Africa/Khartoum',
  },
  {
    id: 'Africa/Kigali',
    name: 'Africa/Kigali',
    value: 'Africa/Kigali',
  },
  {
    id: 'Africa/Kinshasa',
    name: 'Africa/Kinshasa',
    value: 'Africa/Kinshasa',
  },
  {
    id: 'Africa/Lagos',
    name: 'Africa/Lagos',
    value: 'Africa/Lagos',
  },
  {
    id: 'Africa/Libreville',
    name: 'Africa/Libreville',
    value: 'Africa/Libreville',
  },
  {
    id: 'Africa/Lome',
    name: 'Africa/Lome',
    value: 'Africa/Lome',
  },
  {
    id: 'Africa/Luanda',
    name: 'Africa/Luanda',
    value: 'Africa/Luanda',
  },
  {
    id: 'Africa/Lubumbashi',
    name: 'Africa/Lubumbashi',
    value: 'Africa/Lubumbashi',
  },
  {
    id: 'Africa/Lusaka',
    name: 'Africa/Lusaka',
    value: 'Africa/Lusaka',
  },
  {
    id: 'Africa/Malabo',
    name: 'Africa/Malabo',
    value: 'Africa/Malabo',
  },
  {
    id: 'Africa/Maputo',
    name: 'Africa/Maputo',
    value: 'Africa/Maputo',
  },
  {
    id: 'Africa/Maseru',
    name: 'Africa/Maseru',
    value: 'Africa/Maseru',
  },
  {
    id: 'Africa/Mbabane',
    name: 'Africa/Mbabane',
    value: 'Africa/Mbabane',
  },
  {
    id: 'Africa/Mogadishu',
    name: 'Africa/Mogadishu',
    value: 'Africa/Mogadishu',
  },
  {
    id: 'Africa/Monrovia',
    name: 'Africa/Monrovia',
    value: 'Africa/Monrovia',
  },
  {
    id: 'Africa/Nairobi',
    name: 'Africa/Nairobi',
    value: 'Africa/Nairobi',
  },
  {
    id: 'Africa/Ndjamena',
    name: 'Africa/Ndjamena',
    value: 'Africa/Ndjamena',
  },
  {
    id: 'Africa/Niamey',
    name: 'Africa/Niamey',
    value: 'Africa/Niamey',
  },
  {
    id: 'Africa/Nouakchott',
    name: 'Africa/Nouakchott',
    value: 'Africa/Nouakchott',
  },
  {
    id: 'Africa/Ouagadougou',
    name: 'Africa/Ouagadougou',
    value: 'Africa/Ouagadougou',
  },
  {
    id: 'Africa/Porto-Novo',
    name: 'Africa/Porto-Novo',
    value: 'Africa/Porto-Novo',
  },
  {
    id: 'Africa/Sao_Tome',
    name: 'Africa/Sao Tome',
    value: 'Africa/Sao_Tome',
  },
  {
    id: 'Africa/Tripoli',
    name: 'Africa/Tripoli',
    value: 'Africa/Tripoli',
  },
  {
    id: 'Africa/Tunis',
    name: 'Africa/Tunis',
    value: 'Africa/Tunis',
  },
  {
    id: 'Africa/Windhoek',
    name: 'Africa/Windhoek',
    value: 'Africa/Windhoek',
  },
  {
    id: 'America/Adak',
    name: 'America/Adak',
    value: 'America/Adak',
  },
  {
    id: 'America/Anchorage',
    name: 'America/Anchorage',
    value: 'America/Anchorage',
  },
  {
    id: 'America/Anguilla',
    name: 'America/Anguilla',
    value: 'America/Anguilla',
  },
  {
    id: 'America/Antigua',
    name: 'America/Antigua',
    value: 'America/Antigua',
  },
  {
    id: 'America/Araguaina',
    name: 'America/Araguaina',
    value: 'America/Araguaina',
  },
  {
    id: 'America/Argentina/Buenos_Aires',
    name: 'America/Argentina/Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
  },
  {
    id: 'America/Argentina/Catamarca',
    name: 'America/Argentina/Catamarca',
    value: 'America/Argentina/Catamarca',
  },
  {
    id: 'America/Argentina/Cordoba',
    name: 'America/Argentina/Cordoba',
    value: 'America/Argentina/Cordoba',
  },
  {
    id: 'America/Argentina/Jujuy',
    name: 'America/Argentina/Jujuy',
    value: 'America/Argentina/Jujuy',
  },
  {
    id: 'America/Argentina/La_Rioja',
    name: 'America/Argentina/La Rioja',
    value: 'America/Argentina/La_Rioja',
  },
  {
    id: 'America/Argentina/Mendoza',
    name: 'America/Argentina/Mendoza',
    value: 'America/Argentina/Mendoza',
  },
  {
    id: 'America/Argentina/Rio_Gallegos',
    name: 'America/Argentina/Rio Gallegos',
    value: 'America/Argentina/Rio_Gallegos',
  },
  {
    id: 'America/Argentina/Salta',
    name: 'America/Argentina/Salta',
    value: 'America/Argentina/Salta',
  },
  {
    id: 'America/Argentina/San_Juan',
    name: 'America/Argentina/San Juan',
    value: 'America/Argentina/San_Juan',
  },
  {
    id: 'America/Argentina/San_Luis',
    name: 'America/Argentina/San Luis',
    value: 'America/Argentina/San_Luis',
  },
  {
    id: 'America/Argentina/Tucuman',
    name: 'America/Argentina/Tucuman',
    value: 'America/Argentina/Tucuman',
  },
  {
    id: 'America/Argentina/Ushuaia',
    name: 'America/Argentina/Ushuaia',
    value: 'America/Argentina/Ushuaia',
  },
  {
    id: 'America/Aruba',
    name: 'America/Aruba',
    value: 'America/Aruba',
  },
  {
    id: 'America/Asuncion',
    name: 'America/Asuncion',
    value: 'America/Asuncion',
  },
  {
    id: 'America/Atikokan',
    name: 'America/Atikokan',
    value: 'America/Atikokan',
  },
  {
    id: 'America/Bahia',
    name: 'America/Bahia',
    value: 'America/Bahia',
  },
  {
    id: 'America/Bahia_Banderas',
    name: 'America/Bahia Banderas',
    value: 'America/Bahia_Banderas',
  },
  {
    id: 'America/Barbados',
    name: 'America/Barbados',
    value: 'America/Barbados',
  },
  {
    id: 'America/Belem',
    name: 'America/Belem',
    value: 'America/Belem',
  },
  {
    id: 'America/Belize',
    name: 'America/Belize',
    value: 'America/Belize',
  },
  {
    id: 'America/Blanc-Sablon',
    name: 'America/Blanc-Sablon',
    value: 'America/Blanc-Sablon',
  },
  {
    id: 'America/Boa_Vista',
    name: 'America/Boa Vista',
    value: 'America/Boa_Vista',
  },
  {
    id: 'America/Bogota',
    name: 'America/Bogota',
    value: 'America/Bogota',
  },
  {
    id: 'America/Boise',
    name: 'America/Boise',
    value: 'America/Boise',
  },
  {
    id: 'America/Cambridge_Bay',
    name: 'America/Cambridge Bay',
    value: 'America/Cambridge_Bay',
  },
  {
    id: 'America/Campo_Grande',
    name: 'America/Campo Grande',
    value: 'America/Campo_Grande',
  },
  {
    id: 'America/Cancun',
    name: 'America/Cancun',
    value: 'America/Cancun',
  },
  {
    id: 'America/Caracas',
    name: 'America/Caracas',
    value: 'America/Caracas',
  },
  {
    id: 'America/Cayenne',
    name: 'America/Cayenne',
    value: 'America/Cayenne',
  },
  {
    id: 'America/Cayman',
    name: 'America/Cayman',
    value: 'America/Cayman',
  },
  {
    id: 'America/Chicago',
    name: 'America/Chicago',
    value: 'America/Chicago',
  },
  {
    id: 'America/Chihuahua',
    name: 'America/Chihuahua',
    value: 'America/Chihuahua',
  },
  {
    id: 'America/Costa_Rica',
    name: 'America/Costa Rica',
    value: 'America/Costa_Rica',
  },
  {
    id: 'America/Creston',
    name: 'America/Creston',
    value: 'America/Creston',
  },
  {
    id: 'America/Cuiaba',
    name: 'America/Cuiaba',
    value: 'America/Cuiaba',
  },
  {
    id: 'America/Curacao',
    name: 'America/Curacao',
    value: 'America/Curacao',
  },
  {
    id: 'America/Danmarkshavn',
    name: 'America/Danmarkshavn',
    value: 'America/Danmarkshavn',
  },
  {
    id: 'America/Dawson',
    name: 'America/Dawson',
    value: 'America/Dawson',
  },
  {
    id: 'America/Dawson_Creek',
    name: 'America/Dawson Creek',
    value: 'America/Dawson_Creek',
  },
  {
    id: 'America/Denver',
    name: 'America/Denver',
    value: 'America/Denver',
  },
  {
    id: 'America/Detroit',
    name: 'America/Detroit',
    value: 'America/Detroit',
  },
  {
    id: 'America/Dominica',
    name: 'America/Dominica',
    value: 'America/Dominica',
  },
  {
    id: 'America/Edmonton',
    name: 'America/Edmonton',
    value: 'America/Edmonton',
  },
  {
    id: 'America/Eirunepe',
    name: 'America/Eirunepe',
    value: 'America/Eirunepe',
  },
  {
    id: 'America/El_Salvador',
    name: 'America/El Salvador',
    value: 'America/El_Salvador',
  },
  {
    id: 'America/Fort_Nelson',
    name: 'America/Fort Nelson',
    value: 'America/Fort_Nelson',
  },
  {
    id: 'America/Fortaleza',
    name: 'America/Fortaleza',
    value: 'America/Fortaleza',
  },
  {
    id: 'America/Glace_Bay',
    name: 'America/Glace Bay',
    value: 'America/Glace_Bay',
  },
  {
    id: 'America/Nuuk',
    name: 'America/Nuuk',
    value: 'America/Nuuk',
  },
  {
    id: 'America/Goose_Bay',
    name: 'America/Goose Bay',
    value: 'America/Goose_Bay',
  },
  {
    id: 'America/Grand_Turk',
    name: 'America/Grand Turk',
    value: 'America/Grand_Turk',
  },
  {
    id: 'America/Grenada',
    name: 'America/Grenada',
    value: 'America/Grenada',
  },
  {
    id: 'America/Guadeloupe',
    name: 'America/Guadeloupe',
    value: 'America/Guadeloupe',
  },
  {
    id: 'America/Guatemala',
    name: 'America/Guatemala',
    value: 'America/Guatemala',
  },
  {
    id: 'America/Guayaquil',
    name: 'America/Guayaquil',
    value: 'America/Guayaquil',
  },
  {
    id: 'America/Guyana',
    name: 'America/Guyana',
    value: 'America/Guyana',
  },
  {
    id: 'America/Halifax',
    name: 'America/Halifax',
    value: 'America/Halifax',
  },
  {
    id: 'America/Havana',
    name: 'America/Havana',
    value: 'America/Havana',
  },
  {
    id: 'America/Hermosillo',
    name: 'America/Hermosillo',
    value: 'America/Hermosillo',
  },
  {
    id: 'America/Indiana/Indianapolis',
    name: 'America/Indiana/Indianapolis',
    value: 'America/Indiana/Indianapolis',
  },
  {
    id: 'America/Indiana/Knox',
    name: 'America/Indiana/Knox',
    value: 'America/Indiana/Knox',
  },
  {
    id: 'America/Indiana/Marengo',
    name: 'America/Indiana/Marengo',
    value: 'America/Indiana/Marengo',
  },
  {
    id: 'America/Indiana/Petersburg',
    name: 'America/Indiana/Petersburg',
    value: 'America/Indiana/Petersburg',
  },
  {
    id: 'America/Indiana/Tell_City',
    name: 'America/Indiana/Tell City',
    value: 'America/Indiana/Tell_City',
  },
  {
    id: 'America/Indiana/Vevay',
    name: 'America/Indiana/Vevay',
    value: 'America/Indiana/Vevay',
  },
  {
    id: 'America/Indiana/Vincennes',
    name: 'America/Indiana/Vincennes',
    value: 'America/Indiana/Vincennes',
  },
  {
    id: 'America/Indiana/Winamac',
    name: 'America/Indiana/Winamac',
    value: 'America/Indiana/Winamac',
  },
  {
    id: 'America/Inuvik',
    name: 'America/Inuvik',
    value: 'America/Inuvik',
  },
  {
    id: 'America/Iqaluit',
    name: 'America/Iqaluit',
    value: 'America/Iqaluit',
  },
  {
    id: 'America/Jamaica',
    name: 'America/Jamaica',
    value: 'America/Jamaica',
  },
  {
    id: 'America/Juneau',
    name: 'America/Juneau',
    value: 'America/Juneau',
  },
  {
    id: 'America/Kentucky/Louisville',
    name: 'America/Kentucky/Louisville',
    value: 'America/Kentucky/Louisville',
  },
  {
    id: 'America/Kentucky/Monticello',
    name: 'America/Kentucky/Monticello',
    value: 'America/Kentucky/Monticello',
  },
  {
    id: 'America/Kralendijk',
    name: 'America/Kralendijk',
    value: 'America/Kralendijk',
  },
  {
    id: 'America/La_Paz',
    name: 'America/La Paz',
    value: 'America/La_Paz',
  },
  {
    id: 'America/Lima',
    name: 'America/Lima',
    value: 'America/Lima',
  },
  {
    id: 'America/Los_Angeles',
    name: 'America/Los Angeles',
    value: 'America/Los_Angeles',
  },
  {
    id: 'America/Lower_Princes',
    name: 'America/Lower Princes',
    value: 'America/Lower_Princes',
  },
  {
    id: 'America/Maceio',
    name: 'America/Maceio',
    value: 'America/Maceio',
  },
  {
    id: 'America/Managua',
    name: 'America/Managua',
    value: 'America/Managua',
  },
  {
    id: 'America/Manaus',
    name: 'America/Manaus',
    value: 'America/Manaus',
  },
  {
    id: 'America/Marigot',
    name: 'America/Marigot',
    value: 'America/Marigot',
  },
  {
    id: 'America/Martinique',
    name: 'America/Martinique',
    value: 'America/Martinique',
  },
  {
    id: 'America/Matamoros',
    name: 'America/Matamoros',
    value: 'America/Matamoros',
  },
  {
    id: 'America/Mazatlan',
    name: 'America/Mazatlan',
    value: 'America/Mazatlan',
  },
  {
    id: 'America/Menominee',
    name: 'America/Menominee',
    value: 'America/Menominee',
  },
  {
    id: 'America/Merida',
    name: 'America/Merida',
    value: 'America/Merida',
  },
  {
    id: 'America/Metlakatla',
    name: 'America/Metlakatla',
    value: 'America/Metlakatla',
  },
  {
    id: 'America/Mexico_City',
    name: 'America/Mexico City',
    value: 'America/Mexico_City',
  },
  {
    id: 'America/Miquelon',
    name: 'America/Miquelon',
    value: 'America/Miquelon',
  },
  {
    id: 'America/Moncton',
    name: 'America/Moncton',
    value: 'America/Moncton',
  },
  {
    id: 'America/Monterrey',
    name: 'America/Monterrey',
    value: 'America/Monterrey',
  },
  {
    id: 'America/Montevideo',
    name: 'America/Montevideo',
    value: 'America/Montevideo',
  },
  {
    id: 'America/Montserrat',
    name: 'America/Montserrat',
    value: 'America/Montserrat',
  },
  {
    id: 'America/Nassau',
    name: 'America/Nassau',
    value: 'America/Nassau',
  },
  {
    id: 'America/New_York',
    name: 'America/New York',
    value: 'America/New_York',
  },
  {
    id: 'America/Nipigon',
    name: 'America/Nipigon',
    value: 'America/Nipigon',
  },
  {
    id: 'America/Nome',
    name: 'America/Nome',
    value: 'America/Nome',
  },
  {
    id: 'America/Noronha',
    name: 'America/Noronha',
    value: 'America/Noronha',
  },
  {
    id: 'America/North_Dakota/Beulah',
    name: 'America/North Dakota/Beulah',
    value: 'America/North_Dakota/Beulah',
  },
  {
    id: 'America/North_Dakota/Center',
    name: 'America/North Dakota/Center',
    value: 'America/North_Dakota/Center',
  },
  {
    id: 'America/North_Dakota/New_Salem',
    name: 'America/North Dakota/New Salem',
    value: 'America/North_Dakota/New_Salem',
  },
  {
    id: 'America/Ojinaga',
    name: 'America/Ojinaga',
    value: 'America/Ojinaga',
  },
  {
    id: 'America/Panama',
    name: 'America/Panama',
    value: 'America/Panama',
  },
  {
    id: 'America/Pangnirtung',
    name: 'America/Pangnirtung',
    value: 'America/Pangnirtung',
  },
  {
    id: 'America/Paramaribo',
    name: 'America/Paramaribo',
    value: 'America/Paramaribo',
  },
  {
    id: 'America/Phoenix',
    name: 'America/Phoenix',
    value: 'America/Phoenix',
  },
  {
    id: 'America/Port-au-Prince',
    name: 'America/Port-au-Prince',
    value: 'America/Port-au-Prince',
  },
  {
    id: 'America/Port_of_Spain',
    name: 'America/Port of Spain',
    value: 'America/Port_of_Spain',
  },
  {
    id: 'America/Porto_Velho',
    name: 'America/Porto Velho',
    value: 'America/Porto_Velho',
  },
  {
    id: 'America/Puerto_Rico',
    name: 'America/Puerto Rico',
    value: 'America/Puerto_Rico',
  },
  {
    id: 'America/Rainy_River',
    name: 'America/Rainy River',
    value: 'America/Rainy_River',
  },
  {
    id: 'America/Rankin_Inlet',
    name: 'America/Rankin Inlet',
    value: 'America/Rankin_Inlet',
  },
  {
    id: 'America/Recife',
    name: 'America/Recife',
    value: 'America/Recife',
  },
  {
    id: 'America/Regina',
    name: 'America/Regina',
    value: 'America/Regina',
  },
  {
    id: 'America/Resolute',
    name: 'America/Resolute',
    value: 'America/Resolute',
  },
  {
    id: 'America/Rio_Branco',
    name: 'America/Rio Branco',
    value: 'America/Rio_Branco',
  },
  {
    id: 'America/Santarem',
    name: 'America/Santarem',
    value: 'America/Santarem',
  },
  {
    id: 'America/Santiago',
    name: 'America/Santiago',
    value: 'America/Santiago',
  },
  {
    id: 'America/Santo_Domingo',
    name: 'America/Santo Domingo',
    value: 'America/Santo_Domingo',
  },
  {
    id: 'America/Sao_Paulo',
    name: 'America/Sao Paulo',
    value: 'America/Sao_Paulo',
  },
  {
    id: 'America/Scoresbysund',
    name: 'America/Scoresbysund',
    value: 'America/Scoresbysund',
  },
  {
    id: 'America/Sitka',
    name: 'America/Sitka',
    value: 'America/Sitka',
  },
  {
    id: 'America/St_Barthelemy',
    name: 'America/St Barthelemy',
    value: 'America/St_Barthelemy',
  },
  {
    id: 'America/St_Johns',
    name: 'America/St Johns',
    value: 'America/St_Johns',
  },
  {
    id: 'America/St_Kitts',
    name: 'America/St Kitts',
    value: 'America/St_Kitts',
  },
  {
    id: 'America/St_Lucia',
    name: 'America/St Lucia',
    value: 'America/St_Lucia',
  },
  {
    id: 'America/St_Thomas',
    name: 'America/St Thomas',
    value: 'America/St_Thomas',
  },
  {
    id: 'America/St_Vincent',
    name: 'America/St Vincent',
    value: 'America/St_Vincent',
  },
  {
    id: 'America/Swift_Current',
    name: 'America/Swift Current',
    value: 'America/Swift_Current',
  },
  {
    id: 'America/Tegucigalpa',
    name: 'America/Tegucigalpa',
    value: 'America/Tegucigalpa',
  },
  {
    id: 'America/Thule',
    name: 'America/Thule',
    value: 'America/Thule',
  },
  {
    id: 'America/Thunder_Bay',
    name: 'America/Thunder Bay',
    value: 'America/Thunder_Bay',
  },
  {
    id: 'America/Tijuana',
    name: 'America/Tijuana',
    value: 'America/Tijuana',
  },
  {
    id: 'America/Toronto',
    name: 'America/Toronto',
    value: 'America/Toronto',
  },
  {
    id: 'America/Tortola',
    name: 'America/Tortola',
    value: 'America/Tortola',
  },
  {
    id: 'America/Vancouver',
    name: 'America/Vancouver',
    value: 'America/Vancouver',
  },
  {
    id: 'America/Whitehorse',
    name: 'America/Whitehorse',
    value: 'America/Whitehorse',
  },
  {
    id: 'America/Winnipeg',
    name: 'America/Winnipeg',
    value: 'America/Winnipeg',
  },
  {
    id: 'America/Yakutat',
    name: 'America/Yakutat',
    value: 'America/Yakutat',
  },
  {
    id: 'America/Yellowknife',
    name: 'America/Yellowknife',
    value: 'America/Yellowknife',
  },
  {
    id: 'Antarctica/Casey',
    name: 'Antarctica/Casey',
    value: 'Antarctica/Casey',
  },
  {
    id: 'Antarctica/Davis',
    name: 'Antarctica/Davis',
    value: 'Antarctica/Davis',
  },
  {
    id: 'Antarctica/DumontDUrville',
    name: 'Antarctica/DumontDUrville',
    value: 'Antarctica/DumontDUrville',
  },
  {
    id: 'Antarctica/Macquarie',
    name: 'Antarctica/Macquarie',
    value: 'Antarctica/Macquarie',
  },
  {
    id: 'Antarctica/Mawson',
    name: 'Antarctica/Mawson',
    value: 'Antarctica/Mawson',
  },
  {
    id: 'Antarctica/McMurdo',
    name: 'Antarctica/McMurdo',
    value: 'Antarctica/McMurdo',
  },
  {
    id: 'Antarctica/Palmer',
    name: 'Antarctica/Palmer',
    value: 'Antarctica/Palmer',
  },
  {
    id: 'Antarctica/Rothera',
    name: 'Antarctica/Rothera',
    value: 'Antarctica/Rothera',
  },
  {
    id: 'Antarctica/Syowa',
    name: 'Antarctica/Syowa',
    value: 'Antarctica/Syowa',
  },
  {
    id: 'Antarctica/Troll',
    name: 'Antarctica/Troll',
    value: 'Antarctica/Troll',
  },
  {
    id: 'Antarctica/Vostok',
    name: 'Antarctica/Vostok',
    value: 'Antarctica/Vostok',
  },
  {
    id: 'Arctic/Longyearbyen',
    name: 'Arctic/Longyearbyen',
    value: 'Arctic/Longyearbyen',
  },
  {
    id: 'Asia/Aden',
    name: 'Asia/Aden',
    value: 'Asia/Aden',
  },
  {
    id: 'Asia/Almaty',
    name: 'Asia/Almaty',
    value: 'Asia/Almaty',
  },
  {
    id: 'Asia/Amman',
    name: 'Asia/Amman',
    value: 'Asia/Amman',
  },
  {
    id: 'Asia/Anadyr',
    name: 'Asia/Anadyr',
    value: 'Asia/Anadyr',
  },
  {
    id: 'Asia/Aqtau',
    name: 'Asia/Aqtau',
    value: 'Asia/Aqtau',
  },
  {
    id: 'Asia/Aqtobe',
    name: 'Asia/Aqtobe',
    value: 'Asia/Aqtobe',
  },
  {
    id: 'Asia/Ashgabat',
    name: 'Asia/Ashgabat',
    value: 'Asia/Ashgabat',
  },
  {
    id: 'Asia/Atyrau',
    name: 'Asia/Atyrau',
    value: 'Asia/Atyrau',
  },
  {
    id: 'Asia/Baghdad',
    name: 'Asia/Baghdad',
    value: 'Asia/Baghdad',
  },
  {
    id: 'Asia/Bahrain',
    name: 'Asia/Bahrain',
    value: 'Asia/Bahrain',
  },
  {
    id: 'Asia/Baku',
    name: 'Asia/Baku',
    value: 'Asia/Baku',
  },
  {
    id: 'Asia/Bangkok',
    name: 'Asia/Bangkok',
    value: 'Asia/Bangkok',
  },
  {
    id: 'Asia/Barnaul',
    name: 'Asia/Barnaul',
    value: 'Asia/Barnaul',
  },
  {
    id: 'Asia/Beirut',
    name: 'Asia/Beirut',
    value: 'Asia/Beirut',
  },
  {
    id: 'Asia/Bishkek',
    name: 'Asia/Bishkek',
    value: 'Asia/Bishkek',
  },
  {
    id: 'Asia/Brunei',
    name: 'Asia/Brunei',
    value: 'Asia/Brunei',
  },
  {
    id: 'Asia/Chita',
    name: 'Asia/Chita',
    value: 'Asia/Chita',
  },
  {
    id: 'Asia/Choibalsan',
    name: 'Asia/Choibalsan',
    value: 'Asia/Choibalsan',
  },
  {
    id: 'Asia/Colombo',
    name: 'Asia/Colombo',
    value: 'Asia/Colombo',
  },
  {
    id: 'Asia/Damascus',
    name: 'Asia/Damascus',
    value: 'Asia/Damascus',
  },
  {
    id: 'Asia/Dhaka',
    name: 'Asia/Dhaka',
    value: 'Asia/Dhaka',
  },
  {
    id: 'Asia/Dili',
    name: 'Asia/Dili',
    value: 'Asia/Dili',
  },
  {
    id: 'Asia/Dubai',
    name: 'Asia/Dubai',
    value: 'Asia/Dubai',
  },
  {
    id: 'Asia/Dushanbe',
    name: 'Asia/Dushanbe',
    value: 'Asia/Dushanbe',
  },
  {
    id: 'Asia/Famagusta',
    name: 'Asia/Famagusta',
    value: 'Asia/Famagusta',
  },
  {
    id: 'Asia/Gaza',
    name: 'Asia/Gaza',
    value: 'Asia/Gaza',
  },
  {
    id: 'Asia/Hebron',
    name: 'Asia/Hebron',
    value: 'Asia/Hebron',
  },
  {
    id: 'Asia/Ho_Chi_Minh',
    name: 'Asia/Ho Chi Minh',
    value: 'Asia/Ho_Chi_Minh',
  },
  {
    id: 'Asia/Hong_Kong',
    name: 'Asia/Hong Kong',
    value: 'Asia/Hong_Kong',
  },
  {
    id: 'Asia/Hovd',
    name: 'Asia/Hovd',
    value: 'Asia/Hovd',
  },
  {
    id: 'Asia/Irkutsk',
    name: 'Asia/Irkutsk',
    value: 'Asia/Irkutsk',
  },
  {
    id: 'Asia/Jakarta',
    name: 'Asia/Jakarta',
    value: 'Asia/Jakarta',
  },
  {
    id: 'Asia/Jayapura',
    name: 'Asia/Jayapura',
    value: 'Asia/Jayapura',
  },
  {
    id: 'Asia/Jerusalem',
    name: 'Asia/Jerusalem',
    value: 'Asia/Jerusalem',
  },
  {
    id: 'Asia/Kabul',
    name: 'Asia/Kabul',
    value: 'Asia/Kabul',
  },
  {
    id: 'Asia/Kamchatka',
    name: 'Asia/Kamchatka',
    value: 'Asia/Kamchatka',
  },
  {
    id: 'Asia/Karachi',
    name: 'Asia/Karachi',
    value: 'Asia/Karachi',
  },
  {
    id: 'Asia/Kathmandu',
    name: 'Asia/Kathmandu',
    value: 'Asia/Kathmandu',
  },
  {
    id: 'Asia/Khandyga',
    name: 'Asia/Khandyga',
    value: 'Asia/Khandyga',
  },
  {
    id: 'Asia/Kolkata',
    name: 'Asia/Kolkata',
    value: 'Asia/Kolkata',
  },
  {
    id: 'Asia/Krasnoyarsk',
    name: 'Asia/Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
  },
  {
    id: 'Asia/Kuala_Lumpur',
    name: 'Asia/Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
  },
  {
    id: 'Asia/Kuching',
    name: 'Asia/Kuching',
    value: 'Asia/Kuching',
  },
  {
    id: 'Asia/Kuwait',
    name: 'Asia/Kuwait',
    value: 'Asia/Kuwait',
  },
  {
    id: 'Asia/Macau',
    name: 'Asia/Macau',
    value: 'Asia/Macau',
  },
  {
    id: 'Asia/Magadan',
    name: 'Asia/Magadan',
    value: 'Asia/Magadan',
  },
  {
    id: 'Asia/Makassar',
    name: 'Asia/Makassar',
    value: 'Asia/Makassar',
  },
  {
    id: 'Asia/Manila',
    name: 'Asia/Manila',
    value: 'Asia/Manila',
  },
  {
    id: 'Asia/Muscat',
    name: 'Asia/Muscat',
    value: 'Asia/Muscat',
  },
  {
    id: 'Asia/Nicosia',
    name: 'Asia/Nicosia',
    value: 'Asia/Nicosia',
  },
  {
    id: 'Asia/Novokuznetsk',
    name: 'Asia/Novokuznetsk',
    value: 'Asia/Novokuznetsk',
  },
  {
    id: 'Asia/Novosibirsk',
    name: 'Asia/Novosibirsk',
    value: 'Asia/Novosibirsk',
  },
  {
    id: 'Asia/Omsk',
    name: 'Asia/Omsk',
    value: 'Asia/Omsk',
  },
  {
    id: 'Asia/Oral',
    name: 'Asia/Oral',
    value: 'Asia/Oral',
  },
  {
    id: 'Asia/Phnom_Penh',
    name: 'Asia/Phnom Penh',
    value: 'Asia/Phnom_Penh',
  },
  {
    id: 'Asia/Pontianak',
    name: 'Asia/Pontianak',
    value: 'Asia/Pontianak',
  },
  {
    id: 'Asia/Pyongyang',
    name: 'Asia/Pyongyang',
    value: 'Asia/Pyongyang',
  },
  {
    id: 'Asia/Qatar',
    name: 'Asia/Qatar',
    value: 'Asia/Qatar',
  },
  {
    id: 'Asia/Qyzylorda',
    name: 'Asia/Qyzylorda',
    value: 'Asia/Qyzylorda',
  },
  {
    id: 'Asia/Riyadh',
    name: 'Asia/Riyadh',
    value: 'Asia/Riyadh',
  },
  {
    id: 'Asia/Sakhalin',
    name: 'Asia/Sakhalin',
    value: 'Asia/Sakhalin',
  },
  {
    id: 'Asia/Samarkand',
    name: 'Asia/Samarkand',
    value: 'Asia/Samarkand',
  },
  {
    id: 'Asia/Seoul',
    name: 'Asia/Seoul',
    value: 'Asia/Seoul',
  },
  {
    id: 'Asia/Shanghai',
    name: 'Asia/Shanghai',
    value: 'Asia/Shanghai',
  },
  {
    id: 'Asia/Singapore',
    name: 'Asia/Singapore',
    value: 'Asia/Singapore',
  },
  {
    id: 'Asia/Srednekolymsk',
    name: 'Asia/Srednekolymsk',
    value: 'Asia/Srednekolymsk',
  },
  {
    id: 'Asia/Taipei',
    name: 'Asia/Taipei',
    value: 'Asia/Taipei',
  },
  {
    id: 'Asia/Tashkent',
    name: 'Asia/Tashkent',
    value: 'Asia/Tashkent',
  },
  {
    id: 'Asia/Tbilisi',
    name: 'Asia/Tbilisi',
    value: 'Asia/Tbilisi',
  },
  {
    id: 'Asia/Tehran',
    name: 'Asia/Tehran',
    value: 'Asia/Tehran',
  },
  {
    id: 'Asia/Thimphu',
    name: 'Asia/Thimphu',
    value: 'Asia/Thimphu',
  },
  {
    id: 'Asia/Tokyo',
    name: 'Asia/Tokyo',
    value: 'Asia/Tokyo',
  },
  {
    id: 'Asia/Tomsk',
    name: 'Asia/Tomsk',
    value: 'Asia/Tomsk',
  },
  {
    id: 'Asia/Ulaanbaatar',
    name: 'Asia/Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
  },
  {
    id: 'Asia/Urumqi',
    name: 'Asia/Urumqi',
    value: 'Asia/Urumqi',
  },
  {
    id: 'Asia/Ust-Nera',
    name: 'Asia/Ust-Nera',
    value: 'Asia/Ust-Nera',
  },
  {
    id: 'Asia/Vientiane',
    name: 'Asia/Vientiane',
    value: 'Asia/Vientiane',
  },
  {
    id: 'Asia/Vladivostok',
    name: 'Asia/Vladivostok',
    value: 'Asia/Vladivostok',
  },
  {
    id: 'Asia/Yakutsk',
    name: 'Asia/Yakutsk',
    value: 'Asia/Yakutsk',
  },
  {
    id: 'Asia/Yangon',
    name: 'Asia/Yangon',
    value: 'Asia/Yangon',
  },
  {
    id: 'Asia/Yekaterinburg',
    name: 'Asia/Yekaterinburg',
    value: 'Asia/Yekaterinburg',
  },
  {
    id: 'Asia/Yerevan',
    name: 'Asia/Yerevan',
    value: 'Asia/Yerevan',
  },
  {
    id: 'Atlantic/Azores',
    name: 'Atlantic/Azores',
    value: 'Atlantic/Azores',
  },
  {
    id: 'Atlantic/Bermuda',
    name: 'Atlantic/Bermuda',
    value: 'Atlantic/Bermuda',
  },
  {
    id: 'Atlantic/Canary',
    name: 'Atlantic/Canary',
    value: 'Atlantic/Canary',
  },
  {
    id: 'Atlantic/Cape_Verde',
    name: 'Atlantic/Cape Verde',
    value: 'Atlantic/Cape_Verde',
  },
  {
    id: 'Atlantic/Faroe',
    name: 'Atlantic/Faroe',
    value: 'Atlantic/Faroe',
  },
  {
    id: 'Atlantic/Madeira',
    name: 'Atlantic/Madeira',
    value: 'Atlantic/Madeira',
  },
  {
    id: 'Atlantic/Reykjavik',
    name: 'Atlantic/Reykjavik',
    value: 'Atlantic/Reykjavik',
  },
  {
    id: 'Atlantic/South_Georgia',
    name: 'Atlantic/South Georgia',
    value: 'Atlantic/South_Georgia',
  },
  {
    id: 'Atlantic/St_Helena',
    name: 'Atlantic/St Helena',
    value: 'Atlantic/St_Helena',
  },
  {
    id: 'Atlantic/Stanley',
    name: 'Atlantic/Stanley',
    value: 'Atlantic/Stanley',
  },
  {
    id: 'Australia/Adelaide',
    name: 'Australia/Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    id: 'Australia/Brisbane',
    name: 'Australia/Brisbane',
    value: 'Australia/Brisbane',
  },
  {
    id: 'Australia/Broken_Hill',
    name: 'Australia/Broken Hill',
    value: 'Australia/Broken_Hill',
  },
  {
    id: 'Australia/Currie',
    name: 'Australia/Currie',
    value: 'Australia/Currie',
  },
  {
    id: 'Australia/Darwin',
    name: 'Australia/Darwin',
    value: 'Australia/Darwin',
  },
  {
    id: 'Australia/Eucla',
    name: 'Australia/Eucla',
    value: 'Australia/Eucla',
  },
  {
    id: 'Australia/Hobart',
    name: 'Australia/Hobart',
    value: 'Australia/Hobart',
  },
  {
    id: 'Australia/Lindeman',
    name: 'Australia/Lindeman',
    value: 'Australia/Lindeman',
  },
  {
    id: 'Australia/Lord_Howe',
    name: 'Australia/Lord Howe',
    value: 'Australia/Lord_Howe',
  },
  {
    id: 'Australia/Melbourne',
    name: 'Australia/Melbourne',
    value: 'Australia/Melbourne',
  },
  {
    id: 'Australia/Perth',
    name: 'Australia/Perth',
    value: 'Australia/Perth',
  },
  {
    id: 'Australia/Sydney',
    name: 'Australia/Sydney',
    value: 'Australia/Sydney',
  },
  {
    id: 'Europe/Amsterdam',
    name: 'Europe/Amsterdam',
    value: 'Europe/Amsterdam',
  },
  {
    id: 'Europe/Andorra',
    name: 'Europe/Andorra',
    value: 'Europe/Andorra',
  },
  {
    id: 'Europe/Astrakhan',
    name: 'Europe/Astrakhan',
    value: 'Europe/Astrakhan',
  },
  {
    id: 'Europe/Athens',
    name: 'Europe/Athens',
    value: 'Europe/Athens',
  },
  {
    id: 'Europe/Belgrade',
    name: 'Europe/Belgrade',
    value: 'Europe/Belgrade',
  },
  {
    id: 'Europe/Berlin',
    name: 'Europe/Berlin',
    value: 'Europe/Berlin',
  },
  {
    id: 'Europe/Bratislava',
    name: 'Europe/Bratislava',
    value: 'Europe/Bratislava',
  },
  {
    id: 'Europe/Brussels',
    name: 'Europe/Brussels',
    value: 'Europe/Brussels',
  },
  {
    id: 'Europe/Bucharest',
    name: 'Europe/Bucharest',
    value: 'Europe/Bucharest',
  },
  {
    id: 'Europe/Budapest',
    name: 'Europe/Budapest',
    value: 'Europe/Budapest',
  },
  {
    id: 'Europe/Busingen',
    name: 'Europe/Busingen',
    value: 'Europe/Busingen',
  },
  {
    id: 'Europe/Chisinau',
    name: 'Europe/Chisinau',
    value: 'Europe/Chisinau',
  },
  {
    id: 'Europe/Copenhagen',
    name: 'Europe/Copenhagen',
    value: 'Europe/Copenhagen',
  },
  {
    id: 'Europe/Dublin',
    name: 'Europe/Dublin',
    value: 'Europe/Dublin',
  },
  {
    id: 'Europe/Gibraltar',
    name: 'Europe/Gibraltar',
    value: 'Europe/Gibraltar',
  },
  {
    id: 'Europe/Guernsey',
    name: 'Europe/Guernsey',
    value: 'Europe/Guernsey',
  },
  {
    id: 'Europe/Helsinki',
    name: 'Europe/Helsinki',
    value: 'Europe/Helsinki',
  },
  {
    id: 'Europe/Isle_of_Man',
    name: 'Europe/Isle of Man',
    value: 'Europe/Isle_of_Man',
  },
  {
    id: 'Europe/Istanbul',
    name: 'Europe/Istanbul',
    value: 'Europe/Istanbul',
  },
  {
    id: 'Europe/Jersey',
    name: 'Europe/Jersey',
    value: 'Europe/Jersey',
  },
  {
    id: 'Europe/Kaliningrad',
    name: 'Europe/Kaliningrad',
    value: 'Europe/Kaliningrad',
  },
  {
    id: 'Europe/Kiev',
    name: 'Europe/Kiev',
    value: 'Europe/Kiev',
  },
  {
    id: 'Europe/Kirov',
    name: 'Europe/Kirov',
    value: 'Europe/Kirov',
  },
  {
    id: 'Europe/Lisbon',
    name: 'Europe/Lisbon',
    value: 'Europe/Lisbon',
  },
  {
    id: 'Europe/Ljubljana',
    name: 'Europe/Ljubljana',
    value: 'Europe/Ljubljana',
  },
  {
    id: 'Europe/London',
    name: 'Europe/London',
    value: 'Europe/London',
  },
  {
    id: 'Europe/Luxembourg',
    name: 'Europe/Luxembourg',
    value: 'Europe/Luxembourg',
  },
  {
    id: 'Europe/Madrid',
    name: 'Europe/Madrid',
    value: 'Europe/Madrid',
  },
  {
    id: 'Europe/Malta',
    name: 'Europe/Malta',
    value: 'Europe/Malta',
  },
  {
    id: 'Europe/Mariehamn',
    name: 'Europe/Mariehamn',
    value: 'Europe/Mariehamn',
  },
  {
    id: 'Europe/Minsk',
    name: 'Europe/Minsk',
    value: 'Europe/Minsk',
  },
  {
    id: 'Europe/Monaco',
    name: 'Europe/Monaco',
    value: 'Europe/Monaco',
  },
  {
    id: 'Europe/Moscow',
    name: 'Europe/Moscow',
    value: 'Europe/Moscow',
  },
  {
    id: 'Europe/Oslo',
    name: 'Europe/Oslo',
    value: 'Europe/Oslo',
  },
  {
    id: 'Europe/Paris',
    name: 'Europe/Paris',
    value: 'Europe/Paris',
  },
  {
    id: 'Europe/Podgorica',
    name: 'Europe/Podgorica',
    value: 'Europe/Podgorica',
  },
  {
    id: 'Europe/Prague',
    name: 'Europe/Prague',
    value: 'Europe/Prague',
  },
  {
    id: 'Europe/Riga',
    name: 'Europe/Riga',
    value: 'Europe/Riga',
  },
  {
    id: 'Europe/Rome',
    name: 'Europe/Rome',
    value: 'Europe/Rome',
  },
  {
    id: 'Europe/Samara',
    name: 'Europe/Samara',
    value: 'Europe/Samara',
  },
  {
    id: 'Europe/San_Marino',
    name: 'Europe/San Marino',
    value: 'Europe/San_Marino',
  },
  {
    id: 'Europe/Sarajevo',
    name: 'Europe/Sarajevo',
    value: 'Europe/Sarajevo',
  },
  {
    id: 'Europe/Saratov',
    name: 'Europe/Saratov',
    value: 'Europe/Saratov',
  },
  {
    id: 'Europe/Simferopol',
    name: 'Europe/Simferopol',
    value: 'Europe/Simferopol',
  },
  {
    id: 'Europe/Skopje',
    name: 'Europe/Skopje',
    value: 'Europe/Skopje',
  },
  {
    id: 'Europe/Sofia',
    name: 'Europe/Sofia',
    value: 'Europe/Sofia',
  },
  {
    id: 'Europe/Stockholm',
    name: 'Europe/Stockholm',
    value: 'Europe/Stockholm',
  },
  {
    id: 'Europe/Tallinn',
    name: 'Europe/Tallinn',
    value: 'Europe/Tallinn',
  },
  {
    id: 'Europe/Tirane',
    name: 'Europe/Tirane',
    value: 'Europe/Tirane',
  },
  {
    id: 'Europe/Ulyanovsk',
    name: 'Europe/Ulyanovsk',
    value: 'Europe/Ulyanovsk',
  },
  {
    id: 'Europe/Uzhgorod',
    name: 'Europe/Uzhgorod',
    value: 'Europe/Uzhgorod',
  },
  {
    id: 'Europe/Vaduz',
    name: 'Europe/Vaduz',
    value: 'Europe/Vaduz',
  },
  {
    id: 'Europe/Vatican',
    name: 'Europe/Vatican',
    value: 'Europe/Vatican',
  },
  {
    id: 'Europe/Vienna',
    name: 'Europe/Vienna',
    value: 'Europe/Vienna',
  },
  {
    id: 'Europe/Vilnius',
    name: 'Europe/Vilnius',
    value: 'Europe/Vilnius',
  },
  {
    id: 'Europe/Volgograd',
    name: 'Europe/Volgograd',
    value: 'Europe/Volgograd',
  },
  {
    id: 'Europe/Warsaw',
    name: 'Europe/Warsaw',
    value: 'Europe/Warsaw',
  },
  {
    id: 'Europe/Zagreb',
    name: 'Europe/Zagreb',
    value: 'Europe/Zagreb',
  },
  {
    id: 'Europe/Zaporozhye',
    name: 'Europe/Zaporozhye',
    value: 'Europe/Zaporozhye',
  },
  {
    id: 'Europe/Zurich',
    name: 'Europe/Zurich',
    value: 'Europe/Zurich',
  },
  {
    id: 'Indian/Antananarivo',
    name: 'Indian/Antananarivo',
    value: 'Indian/Antananarivo',
  },
  {
    id: 'Indian/Chagos',
    name: 'Indian/Chagos',
    value: 'Indian/Chagos',
  },
  {
    id: 'Indian/Christmas',
    name: 'Indian/Christmas',
    value: 'Indian/Christmas',
  },
  {
    id: 'Indian/Cocos',
    name: 'Indian/Cocos',
    value: 'Indian/Cocos',
  },
  {
    id: 'Indian/Comoro',
    name: 'Indian/Comoro',
    value: 'Indian/Comoro',
  },
  {
    id: 'Indian/Kerguelen',
    name: 'Indian/Kerguelen',
    value: 'Indian/Kerguelen',
  },
  {
    id: 'Indian/Mahe',
    name: 'Indian/Mahe',
    value: 'Indian/Mahe',
  },
  {
    id: 'Indian/Maldives',
    name: 'Indian/Maldives',
    value: 'Indian/Maldives',
  },
  {
    id: 'Indian/Mauritius',
    name: 'Indian/Mauritius',
    value: 'Indian/Mauritius',
  },
  {
    id: 'Indian/Mayotte',
    name: 'Indian/Mayotte',
    value: 'Indian/Mayotte',
  },
  {
    id: 'Indian/Reunion',
    name: 'Indian/Reunion',
    value: 'Indian/Reunion',
  },
  {
    id: 'Pacific/Apia',
    name: 'Pacific/Apia',
    value: 'Pacific/Apia',
  },
  {
    id: 'Pacific/Auckland',
    name: 'Pacific/Auckland',
    value: 'Pacific/Auckland',
  },
  {
    id: 'Pacific/Bougainville',
    name: 'Pacific/Bougainville',
    value: 'Pacific/Bougainville',
  },
  {
    id: 'Pacific/Chatham',
    name: 'Pacific/Chatham',
    value: 'Pacific/Chatham',
  },
  {
    id: 'Pacific/Chuuk',
    name: 'Pacific/Chuuk',
    value: 'Pacific/Chuuk',
  },
  {
    id: 'Pacific/Easter',
    name: 'Pacific/Easter',
    value: 'Pacific/Easter',
  },
  {
    id: 'Pacific/Efate',
    name: 'Pacific/Efate',
    value: 'Pacific/Efate',
  },
  {
    id: 'Pacific/Kanton',
    name: 'Pacific/Kanton',
    value: 'Pacific/Kanton',
  },
  {
    id: 'Pacific/Fakaofo',
    name: 'Pacific/Fakaofo',
    value: 'Pacific/Fakaofo',
  },
  {
    id: 'Pacific/Fiji',
    name: 'Pacific/Fiji',
    value: 'Pacific/Fiji',
  },
  {
    id: 'Pacific/Funafuti',
    name: 'Pacific/Funafuti',
    value: 'Pacific/Funafuti',
  },
  {
    id: 'Pacific/Galapagos',
    name: 'Pacific/Galapagos',
    value: 'Pacific/Galapagos',
  },
  {
    id: 'Pacific/Gambier',
    name: 'Pacific/Gambier',
    value: 'Pacific/Gambier',
  },
  {
    id: 'Pacific/Guadalcanal',
    name: 'Pacific/Guadalcanal',
    value: 'Pacific/Guadalcanal',
  },
  {
    id: 'Pacific/Guam',
    name: 'Pacific/Guam',
    value: 'Pacific/Guam',
  },
  {
    id: 'Pacific/Honolulu',
    name: 'Pacific/Honolulu',
    value: 'Pacific/Honolulu',
  },
  {
    id: 'Pacific/Johnston',
    name: 'Pacific/Johnston',
    value: 'Pacific/Johnston',
  },
  {
    id: 'Pacific/Kiritimati',
    name: 'Pacific/Kiritimati',
    value: 'Pacific/Kiritimati',
  },
  {
    id: 'Pacific/Kosrae',
    name: 'Pacific/Kosrae',
    value: 'Pacific/Kosrae',
  },
  {
    id: 'Pacific/Kwajalein',
    name: 'Pacific/Kwajalein',
    value: 'Pacific/Kwajalein',
  },
  {
    id: 'Pacific/Majuro',
    name: 'Pacific/Majuro',
    value: 'Pacific/Majuro',
  },
  {
    id: 'Pacific/Marquesas',
    name: 'Pacific/Marquesas',
    value: 'Pacific/Marquesas',
  },
  {
    id: 'Pacific/Midway',
    name: 'Pacific/Midway',
    value: 'Pacific/Midway',
  },
  {
    id: 'Pacific/Nauru',
    name: 'Pacific/Nauru',
    value: 'Pacific/Nauru',
  },
  {
    id: 'Pacific/Niue',
    name: 'Pacific/Niue',
    value: 'Pacific/Niue',
  },
  {
    id: 'Pacific/Norfolk',
    name: 'Pacific/Norfolk',
    value: 'Pacific/Norfolk',
  },
  {
    id: 'Pacific/Noumea',
    name: 'Pacific/Noumea',
    value: 'Pacific/Noumea',
  },
  {
    id: 'Pacific/Pago_Pago',
    name: 'Pacific/Pago Pago',
    value: 'Pacific/Pago_Pago',
  },
  {
    id: 'Pacific/Palau',
    name: 'Pacific/Palau',
    value: 'Pacific/Palau',
  },
  {
    id: 'Pacific/Pitcairn',
    name: 'Pacific/Pitcairn',
    value: 'Pacific/Pitcairn',
  },
  {
    id: 'Pacific/Pohnpei',
    name: 'Pacific/Pohnpei',
    value: 'Pacific/Pohnpei',
  },
  {
    id: 'Pacific/Port_Moresby',
    name: 'Pacific/Port Moresby',
    value: 'Pacific/Port_Moresby',
  },
  {
    id: 'Pacific/Rarotonga',
    name: 'Pacific/Rarotonga',
    value: 'Pacific/Rarotonga',
  },
  {
    id: 'Pacific/Saipan',
    name: 'Pacific/Saipan',
    value: 'Pacific/Saipan',
  },
  {
    id: 'Pacific/Tahiti',
    name: 'Pacific/Tahiti',
    value: 'Pacific/Tahiti',
  },
  {
    id: 'Pacific/Tarawa',
    name: 'Pacific/Tarawa',
    value: 'Pacific/Tarawa',
  },
  {
    id: 'Pacific/Tongatapu',
    name: 'Pacific/Tongatapu',
    value: 'Pacific/Tongatapu',
  },
  {
    id: 'Pacific/Wake',
    name: 'Pacific/Wake',
    value: 'Pacific/Wake',
  },
  {
    id: 'Pacific/Wallis',
    name: 'Pacific/Wallis',
    value: 'Pacific/Wallis',
  },
  {
    id: 'UTC-12',
    name: 'UTC-12',
    value: 'UTC-12',
    intlValue: '-12:00',
  },
  {
    id: 'UTC-11:30',
    name: 'UTC-11:30',
    value: 'UTC-11:30',
    intlValue: '-11:30',
  },
  {
    id: 'UTC-11',
    name: 'UTC-11',
    value: 'UTC-11',
    intlValue: '-11:00',
  },
  {
    id: 'UTC-10:30',
    name: 'UTC-10:30',
    value: 'UTC-10:30',
    intlValue: '-10:30',
  },
  {
    id: 'UTC-10',
    name: 'UTC-10',
    value: 'UTC-10',
    intlValue: '-10:00',
  },
  {
    id: 'UTC-9:30',
    name: 'UTC-9:30',
    value: 'UTC-9:30',
    intlValue: '-09:30',
  },
  {
    id: 'UTC-9',
    name: 'UTC-9',
    value: 'UTC-9',
    intlValue: '-09:00',
  },
  {
    id: 'UTC-8:30',
    name: 'UTC-8:30',
    value: 'UTC-8:30',
    intlValue: '-08:30',
  },
  {
    id: 'UTC-8',
    name: 'UTC-8',
    value: 'UTC-8',
    intlValue: '-08:00',
  },
  {
    id: 'UTC-7:30',
    name: 'UTC-7:30',
    value: 'UTC-7:30',
    intlValue: '-07:30',
  },
  {
    id: 'UTC-7',
    name: 'UTC-7',
    value: 'UTC-7',
    intlValue: '-07:00',
  },
  {
    id: 'UTC-6:30',
    name: 'UTC-6:30',
    value: 'UTC-6:30',
    intlValue: '-06:30',
  },
  {
    id: 'UTC-6',
    name: 'UTC-6',
    value: 'UTC-6',
    intlValue: '-06:00',
  },
  {
    id: 'UTC-5:30',
    name: 'UTC-5:30',
    value: 'UTC-5:30',
    intlValue: '-05:30',
  },
  {
    id: 'UTC-5',
    name: 'UTC-5',
    value: 'UTC-5',
    intlValue: '-05:00',
  },
  {
    id: 'UTC-4:30',
    name: 'UTC-4:30',
    value: 'UTC-4:30',
    intlValue: '-04:30',
  },
  {
    id: 'UTC-4',
    name: 'UTC-4',
    value: 'UTC-4',
    intlValue: '-04:00',
  },
  {
    id: 'UTC-3:30',
    name: 'UTC-3:30',
    value: 'UTC-3:30',
    intlValue: '-03:30',
  },
  {
    id: 'UTC-3',
    name: 'UTC-3',
    value: 'UTC-3',
    intlValue: '-03:00',
  },
  {
    id: 'UTC-2:30',
    name: 'UTC-2:30',
    value: 'UTC-2:30',
    intlValue: '-02:30',
  },
  {
    id: 'UTC-2',
    name: 'UTC-2',
    value: 'UTC-2',
    intlValue: '-02:00',
  },
  {
    id: 'UTC-1:30',
    name: 'UTC-1:30',
    value: 'UTC-1:30',
    intlValue: '-01:30',
  },
  {
    id: 'UTC-1',
    name: 'UTC-1',
    value: 'UTC-1',
    intlValue: '-01:00',
  },
  {
    id: 'UTC-0:30',
    name: 'UTC-0:30',
    value: 'UTC-0:30',
    intlValue: '-00:30',
  },
  {
    id: 'UTC',
    name: 'UTC',
    value: 'UTC',
  },
  {
    id: 'UTC+0:30',
    name: 'UTC+0:30',
    value: 'UTC+0:30',
    intlValue: '+00:30',
  },
  {
    id: 'UTC+1',
    name: 'UTC+1',
    value: 'UTC+1',
    intlValue: '+01:00',
  },
  {
    id: 'UTC+1:30',
    name: 'UTC+1:30',
    value: 'UTC+1:30',
    intlValue: '+01:30',
  },
  {
    id: 'UTC+2',
    name: 'UTC+2',
    value: 'UTC+2',
    intlValue: '+02:00',
  },
  {
    id: 'UTC+2:30',
    name: 'UTC+2:30',
    value: 'UTC+2:30',
    intlValue: '+02:30',
  },
  {
    id: 'UTC+3',
    name: 'UTC+3',
    value: 'UTC+3',
    intlValue: '+03:00',
  },
  {
    id: 'UTC+3:30',
    name: 'UTC+3:30',
    value: 'UTC+3:30',
    intlValue: '+03:30',
  },
  {
    id: 'UTC+4',
    name: 'UTC+4',
    value: 'UTC+4',
    intlValue: '+04:00',
  },
  {
    id: 'UTC+4:30',
    name: 'UTC+4:30',
    value: 'UTC+4:30',
    intlValue: '+04:30',
  },
  {
    id: 'UTC+5',
    name: 'UTC+5',
    value: 'UTC+5',
    intlValue: '+05:00',
  },
  {
    id: 'UTC+5:30',
    name: 'UTC+5:30',
    value: 'UTC+5:30',
    intlValue: '+05:30',
  },
  {
    id: 'UTC+5:45',
    name: 'UTC+5:45',
    value: 'UTC+5:45',
    intlValue: '+05:45',
  },
  {
    id: 'UTC+6',
    name: 'UTC+6',
    value: 'UTC+6',
    intlValue: '+06:00',
  },
  {
    id: 'UTC+6:30',
    name: 'UTC+6:30',
    value: 'UTC+6:30',
    intlValue: '+06:30',
  },
  {
    id: 'UTC+7',
    name: 'UTC+7',
    value: 'UTC+7',
    intlValue: '+07:00',
  },
  {
    id: 'UTC+7:30',
    name: 'UTC+7:30',
    value: 'UTC+7:30',
    intlValue: '+07:30',
  },
  {
    id: 'UTC+8',
    name: 'UTC+8',
    value: 'UTC+8',
    intlValue: '+08:00',
  },
  {
    id: 'UTC+8:30',
    name: 'UTC+8:30',
    value: 'UTC+8:30',
    intlValue: '+08:30',
  },
  {
    id: 'UTC+8:45',
    name: 'UTC+8:45',
    value: 'UTC+8:45',
    intlValue: '+08:45',
  },
  {
    id: 'UTC+9',
    name: 'UTC+9',
    value: 'UTC+9',
    intlValue: '+09:00',
  },
  {
    id: 'UTC+9:30',
    name: 'UTC+9:30',
    value: 'UTC+9:30',
    intlValue: '+09:30',
  },
  {
    id: 'UTC+10',
    name: 'UTC+10',
    value: 'UTC+10',
    intlValue: '+10:00',
  },
  {
    id: 'UTC+10:30',
    name: 'UTC+10:30',
    value: 'UTC+10:30',
    intlValue: '+10:30',
  },
  {
    id: 'UTC+11',
    name: 'UTC+11',
    value: 'UTC+11',
    intlValue: '+11:00',
  },
  {
    id: 'UTC+11:30',
    name: 'UTC+11:30',
    value: 'UTC+11:30',
    intlValue: '+11:30',
  },
  {
    id: 'UTC+12',
    name: 'UTC+12',
    value: 'UTC+12',
    intlValue: '+12:00',
  },
  {
    id: 'UTC+12:45',
    name: 'UTC+12:45',
    value: 'UTC+12:45',
    intlValue: '+12:45',
  },
  {
    id: 'UTC+13',
    name: 'UTC+13',
    value: 'UTC+13',
    intlValue: '+13:00',
  },
  {
    id: 'UTC+13:45',
    name: 'UTC+13:45',
    value: 'UTC+13:45',
    intlValue: '+13:45',
  },
  {
    id: 'UTC+14',
    name: 'UTC+14',
    value: 'UTC+14',
    intlValue: '+14:00',
  },
];
